const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  validate: 'تحقق',
  back: 'عودة',
  error: 'خطأ',
  active: 'سارية',
  dashboard: 'لوحة المعلومات',
  verificationServices: 'خدمات التحقق',
  judicalLicenseVerification: 'التحقق من ترخيص عدلي',
  judicalLicenseDescription: 'خدمة تساعدك على التحقق من صحة التراخيص التي يتم اصدارها من وزارة العدل',
  hijriDateSuffix: 'هـ',
  georgianDateSuffix: 'م',
  lawyer: 'محامي',
  trainee: 'متدرب',
  licenseToRepresentaPrivateLegalPerson: 'ترخيص ترافع عن الشخصية المعنوية الخاصة',
  mwathiq: 'موثق',
  authorized: 'مأذون',
  implementationServiceProvider: 'مقدم خدمات التنفيذ',

  licenseType: 'نوع الترخيص',
  chooseLicenseType: 'اختر نوع الترخيص',
  licenseNumber: 'رقم الترخيص',
  licenseNumberPlaceholder: 'مثال:123',
  licenseDetails: 'بيانات الترخيص',
  serviceType: 'نوع الخدمة ',
  issuanceDate: 'تاريخ الإصدار',
  terminationDate: 'تاريخ الانتهاء',
  noResult: 'لا يوجد نتائج',
  docIdCopiedSuccessfully: 'تم نسخ رقم الترخيص بنجاح',

  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
  },

  name: 'الإسم',
  socialID: 'رقم الهوية',
  licenseHolderInformation: 'بيانات صاحب الترخيص',
  lawyerTrainerInformation: 'بيانات المحامي المُدرب',
  entityInformation: 'بيانات الكيان',
  entityName: 'اسم الكيان',
  mobileNumber: 'رقم الجوال',
  city: 'المدينة',
  court: 'المحكمة',
  institutionInformations: 'بيانات المنشأة',
  institutionName: 'اسم المنشأة',
  crNumber: 'رقم السجل التجاري',
  phone: 'الهاتف',
  mobile: 'الجوال',
  institutionAddress: 'عنوان المنشأة',
  district: 'المنطقة',
  neighborhood: 'الحي',
  street: 'الشارع',
  licencedAreas: 'المناطق المرخصة',
  backToVerification: 'العودة للتحقق',

  serverErrors: {
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
    NO_DATA_FOUND: 'لا توجد بيانات متاحة',
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
  },
};

export default ar;
